import { useEffect, useState } from 'react';

const personalLinesURL = '/personal-lines';

const Tabs = ({ isPersonalLines, isPersonalLineActive = false }) => {
    const [prevLocation] = useState(window.history.state?.prevLocation || '/');

    const tabs = [
        { name: 'BUSINESS', href: '/', isActive: !isPersonalLines },
        { name: 'PERSONAL', href: personalLinesURL, isActive: isPersonalLines },
    ];

    useEffect(() => {
        if (!isPersonalLines) {
            window.history.replaceState({ prevLocation: window.location.href }, document.title, window.location.href);
        }
    }, [isPersonalLines]);

    const handleTabClick = (href, isActive) => {
        if (!isActive && !isPersonalLines) {
            window.history.pushState({ prevLocation: window.location.href }, document.title, href);
            window.location.href = href; // Navigate to the new URL
        } else if (!isActive && isPersonalLines && prevLocation !== personalLinesURL) {
            window.location.href = prevLocation; // Navigate to the previous URL
        } else {
            window.location.href = href; // Navigate to the current URL
        }
    };

    return (
        isPersonalLineActive && (
            <div className="form-tabs-container">
                {tabs.map(tab => {
                    const Tag = tab.isActive ? 'div' : 'a';
                    return (
                        <Tag
                            key={tab.name}
                            href={tab.isActive ? undefined : tab.href}
                            className={`form-tab ${tab.isActive ? '' : 'inactive'}`}
                            onClick={e => {
                                if (!tab.isActive) {
                                    e.preventDefault();
                                    handleTabClick(tab.href, tab.isActive);
                                }
                            }}
                        >
                            <span className="body-2b">{tab.name}</span>
                        </Tag>
                    );
                })}
            </div>
        )
    );
};

export default Tabs;
